module.exports = __webpack_public_path__ + "static/media/brand.71eb4ece.png";